import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Solo per le chiamate API al nostro backend
    if (!this.isApiCall(req.url)) {
      return next.handle(req);
    }

    // Se la richiesta ha già un Authorization header, non fare nulla (bypass per getWithToken/postWithToken)
    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    // Ottieni il token corrente dal servizio auth
    return this.authService.getIdToken().pipe(
      take(1), // Prendi solo il valore corrente
      switchMap(accessToken => {
        let authReq = req;

        // Se abbiamo un token, aggiungilo all'header Authorization
        if (accessToken) {
          authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${accessToken}`
            }
          });
        }

        return next.handle(authReq);
      })
    );
  }

  /**
   * Verifica se la richiesta è diretta alla nostra API
   */
  private isApiCall(url: string): boolean {
    // Controlla se l'URL inizia con il nostro apiUrl
    if (url.startsWith(environment.apiUrl)) {
      return true;
    }

    // Controlla se è un URL relativo che inizia con /
    if (url.startsWith('/') && !url.startsWith('//')) {
      return true;
    }

    // Per URL assoluti, controlla se contiene il nostro dominio API
    try {
      const urlObj = new URL(url);
      const apiUrlObj = new URL(environment.apiUrl);
      return urlObj.origin === apiUrlObj.origin;
    } catch {
      // Se non è un URL valido, assumiamo che non sia una chiamata API
      return false;
    }
  }
}
